import { api } from './api'

export const fileService = {
  // Download de arquivo por ID
  async downloadFile(fileId: number): Promise<Blob> {
    try {
      const response = await api.get(`/get-file/${fileId}`, {
        responseType: 'blob', // Importante para download de arquivos
      })
      
      return response.data
    } catch (error: any) {
      console.error('Erro ao fazer download do arquivo:', error)
      throw new Error(error.response?.data?.message || 'Erro ao fazer download do arquivo')
    }
  },

  // Helper para iniciar download no browser
  downloadBlob(blob: Blob, fileName: string = 'arquivo') {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  },

  // Função completa para download direto
  async downloadFileById(fileId: number, fileName?: string): Promise<void> {
    try {
      const blob = await this.downloadFile(fileId)
      const finalFileName = fileName || `arquivo_${fileId}`
      this.downloadBlob(blob, finalFileName)
    } catch (error) {
      throw error
    }
  }
}
